import { render, staticRenderFns } from "./DemandeAlignement.vue?vue&type=template&id=6830c9c4"
import script from "./DemandeAlignement.vue?vue&type=script&lang=js"
export * from "./DemandeAlignement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports